const linearGradient = (color: string, colorState: string, angle = 310): string =>
  `linear-gradient(${angle}deg, ${color}, ${colorState})`

export default linearGradient
